/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import {
    Container, Card
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import {
    Stack, TextField, IconButton, InputAdornment, Tooltip,
    Button, Box, Grid
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@mui/material/TablePagination';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Service';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles'
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import SearchNotFound from '../../../SearchNotFound';
import Chip from '@material-ui/core/Chip';
import { AlertDialog } from './../../Common/AlertDialog';
import { makeStyles } from '@material-ui/styles';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import { CustomTable } from './CustomTable';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    {
        id: 'registrationNumber',
        numeric: false,
        disablePadding: false,
        label: 'Supplier Code - Agrithmics',
        align: "left"
    },
    {
        id: 'givenName',
        numeric: false,
        disablePadding: false,
        label: 'Business / Supplier Name',
        align: "left"
    },
    {
        id: 'mobileNumber',
        numeric: false,
        disablePadding: false,
        label: 'Phone Number',
        align: "left"
    },
    {
        id: 'nic',
        numeric: false,
        disablePadding: false,
        label: 'NIC / BRN',
        align: "left"
    },
    {
        id: 'farmerStatus',
        numeric: false,
        disablePadding: false,
        label: 'Status',
        align: "left"
    },
    {
        id: 'action',
        numeric: false,
        disablePadding: false,
        label: 'Action',
        align: "center"
    },
];

const headCellsOne = [
    {
        id: 'registrationNumber',
        numeric: false,
        disablePadding: false,
        label: 'Supplier Code - Agrithmics',
        align: "left"
    },
    {
        id: 'givenName',
        numeric: false,
        disablePadding: false,
        label: 'Business / Supplier Name',
        align: "left"
    },
    {
        id: 'farmerTypeID',
        numeric: false,
        disablePadding: false,
        label: 'Supplier Type',
        align: "left"
    },
    {
        id: 'nic',
        numeric: false,
        disablePadding: false,
        label: 'NIC / BRN',
        align: "left"
    },
    {
        id: 'farmerStatus',
        numeric: false,
        disablePadding: false,
        label: 'Status',
        align: "left"
    },
    {
        id: 'rejectReason',
        numeric: false,
        disablePadding: false,
        label: 'Reject Reason',
        align: "left"
    }
];

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

function EnhancedTableHeadOne(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCellsOne.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                    >
                        {headCell.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));

var screenCode = "FARMER"

export default function FarmerListing(props) {
    const classes = useStyles();
    const [message, setMessage] = useState("FCC Approve Confirmation");
    const [message1, setMessage1] = useState("FDC First Approve Confirmation");
    const [message2, setMessage2] = useState("FDC Second Approve Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);

    const [approveFarmerDetails, setApproveFarmerDetails] = useState({
        farmerID: 0,
        farmerStatus: 0,
        collectionCenterID: 0,
        farmerCode: "",
        givenName: "",
        navisionNumber: "",

    });
    const [editFarmer, setEditFarmer] = useState(0);
    const [editFarmerCollectionCenterID, setEditFarmerCollectionCenterID] = useState(0);
    const [approveFarmer, setApproveFarmer] = useState(0);
    const [approveStatus, setApproveStatus] = useState(0);
    const [approveFarmerCode, setApproveFarmerCode] = useState("");
    const [approveGivenName, setApproveGivenName] = useState("");
    const [approveCollectionCenterID, setApprovecollectionCenterID] = useState(0);
    const [rejectFarmer, setRejectFarmer] = useState("");
    const [rejectStatus, setRejectStatus] = useState("");
    const [approvenavisionNumber, setApproveNavisionNumber] = useState("");
    const [farmerDetails, setFarmerDetails] = useState([]);
    const [farmerRejectDetails, setFarmerRejectDetails] = useState([]);
    const [farmerDetails1, setFarmerDetails1] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [isEnable, setIsEnable] = useState(true);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [factoryType, setFactoryType] = useState(0);
    let encrypted = "";
    const navigate = useNavigate();
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const [cropData, setCropData] = useState({
        farmerName: ''
    });

    const [formData, setFormData] = useState({
        groupID: "0",
        operationEntityID: "0",
        rejectReason: "",
        isActive: "0",
        farmerTypeID: "0"
    });

    const [searchQuery, setSearchQuery] = useState('');

    const productcatogerySearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.number()
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            isActive: formData.isActive,
            farmerTypeID: formData.farmerTypeID
        },
        validationSchema: productcatogerySearchSchema,
        onSubmit: (values) => {
            setIsEnable(false);
            trackPromise(GetFarmersByGroupIDAndOperationEntityID(values));
        },
    });

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        const IDdata = JSON.parse(
            sessionStorage.getItem('farmer-listing-page-search-parameters-id')
        );
        const tablePage = JSON.parse(
            sessionStorage.getItem('farmer-table-page')
        );

        if (IDdata !== null) {
            setPage(tablePage);
            setIsEnable(false);
            trackPromise(GetFarmersByGroupIDAndOperationEntityID(IDdata));
        }
        getPermissions(IDdata, tablePage);
    }, []);

    useEffect(() => {
        sessionStorage.removeItem(
            'farmer-listing-page-search-parameters-id'
        );
        sessionStorage.removeItem('farmer-table-page');
    }, []);

    useEffect(() => {
        if (editFarmer != 0) {
            EditFarmer(editFarmer, editFarmerCollectionCenterID)
        }
    }, [editFarmer]);

    useEffect(() => {
        if (approveFarmer != 0) {
            handleConfirm(approveFarmer, approveStatus, approveFarmerCode, approveGivenName, approveCollectionCenterID, approvenavisionNumber)
        }
    }, [approveFarmer]);

    useEffect(() => {
        if (rejectFarmer != 0) {
            handleReject(rejectFarmer, rejectStatus)
        }
    }, [rejectFarmer]);

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setFarmerDetails([]);
        setPage(0);
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setFarmerDetails([]);
        setPage(0);
    }, [formik.values.isActive]);

    useEffect(() => {
        setFarmerDetails([]);
        setPage(0);
    }, [formik.values.farmerTypeID]);

    useEffect(() => {
        handleSearch(cropData.farmerName);
    }, [cropData.farmerName]);

    useEffect(() => {
        setPage(0);
    }, [searchQuery]);

    const filteredFarmerRejectDetails = farmerRejectDetails.filter((row) => {
        return (
            row.registrationNumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
            (row.modeOfOperation === 1 ? row.givenName || row.businessName : row.givenName).toLowerCase().includes(searchQuery.toLowerCase()) ||
            row.nic.toLowerCase().includes(searchQuery.toLowerCase()) ||
            row.rejectReason.toLowerCase().includes(searchQuery.toLowerCase())
        );
    });
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('date');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - farmerDetails.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const paginatedRows = stableSort(filteredFarmerRejectDetails, getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };


    async function getPermissions(IDdata, tablePage) {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFARMER');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        const isInitialLoad = IDdata === null;

        if (isInitialLoad) {
            setValues({
                ...values,
                groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
                operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
            })
        }
        else {
            setValues({
                ...values,
                groupID: IDdata.groupID,
                operationEntityID: IDdata.operationEntityID,
                isActive: IDdata.isActive
            })
            setPage(tablePage);
        }
        setFactoryType(parseInt(TokenDecoder.getFactoryTypeFromToken()))
        trackPromise(GetAllGroups());
    }

    async function GetFarmersByGroupIDAndOperationEntityID(values) {
        setCropData({
            ...cropData,
            farmerName: ""
        })
        const res = await services.GetFarmersByGroupIDAndOperationEntityID(values);
        if (res.statusCode == "Success") {
            setFarmerRejectDetails(res.data.detailsTwo)
            setFarmerDetails(res.data.detailsOne);

            setFarmerDetails1(res.data.detailsOne);
        }
    }

    async function EditFarmer(farmerID, farmerCollectionCenterID) {
        encrypted = AESEncryptionParam(farmerID.toString());
        let encrypted1 = AESEncryptionParam(farmerCollectionCenterID.toString());
        let modelID = {
            groupID: parseInt(values.groupID),
            operationEntityID: parseInt(values.operationEntityID),
            isActive: parseInt(values.isActive),
            farmerTypeID: parseInt(values.farmerTypeID)
        };
        sessionStorage.setItem(
            'farmer-listing-page-search-parameters-id',
            JSON.stringify(modelID)
        );
        sessionStorage.setItem(
            'farmer-table-page',
            JSON.stringify(page)
        );
        navigate('/dashboard/farmer/addedit/' + encrypted + "/" + encrypted1)
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        var res = await services.GetAllFactoriesByGroupID(formik.values.groupID);
        if (res != null) {
            setOperationEntityList(res);
        }
    }

    function generateGroupForDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                items.push(<MenuItem key={x.groupID} value={x.groupID}>{x.groupName}</MenuItem>)
            });
        }
        return items
    }

    function generateOperationEntityForDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                x.factoryType == 2 ? items.push(<MenuItem key={x.factoryID} value={x.factoryID}>{x.factoryName}</MenuItem>) :
                    null
            });
        }
        return items
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value
        setCropData({
            ...cropData,
            farmerName: value
        });
    }

    async function handleSearch(data) {
        if (farmerDetails == null || farmerDetails.length == 0) {
            setFarmerDetails(farmerDetails1)
        }
        const Default = [];
        for (let i = 0; i < farmerDetails.length; i++) {
            const obj = farmerDetails[i];

            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    const propertyValue = obj[key];
                    if (propertyValue != null) {
                        const newPropertyValue = propertyValue.toString().toLowerCase();
                        if (typeof newPropertyValue === 'string' && newPropertyValue.includes(data.toLowerCase())) {
                            Default.push(obj);
                            break;
                        }
                    }
                }
            }
        }
        if (data == '') {
            setFarmerDetails(farmerDetails1)
            return;
        }
        setFarmerDetails(Default)
    }

    function clear() {
        setIsEnable(true);
        setFarmerDetails([]);
    }

    async function ApproveFarmer(farmerID, farmerStatus, farmerCode, givenName, collectionCenterID, navisionNumber) {
        var res = await services.ApproveFarmer(farmerID, farmerStatus, farmerCode, givenName, collectionCenterID, navisionNumber);
        if (res.statusCode === "Success") {
            toast.success(farmerStatus == 2 ? "FCC Approved successfully"
                : farmerStatus == 3 ? "FDC First Approved successfully" : "FDC Second Approved successfully");
            trackPromise(GetFarmersByGroupIDAndOperationEntityID(values));
        } else {
            toast.error("Error occured in Farmer Apprival");
        }
    }

    function confirmData(y) {
        if (y) {
            ApproveFarmer(approveFarmerDetails.farmerID, approveFarmerDetails.farmerStatus, approveFarmerDetails.farmerCode, approveFarmerDetails.givenName, approveFarmerDetails.collectionCenterID, approveFarmerDetails.navisionNumber);
        }
    }

    async function handleConfirm(farmerID, farmerStatus, farmerCode, givenName, collectionCenterID, navisionNumber) {
        setApproveFarmerDetails({
            ...approveFarmerDetails,
            farmerID: parseInt(farmerID),
            farmerStatus: parseInt(farmerStatus),
            farmerCode: (farmerCode),
            givenName: (givenName),
            collectionCenterID: parseInt(collectionCenterID),
            navisionNumber: (navisionNumber)
        })
        var res = await services.CheckFarmerDocumentAvailability(farmerID);
        if (res == 4) {
            setEnableConfirmMessage(true);
        }
        else {
            setResult(res)
            setOpen(true);
        }
        setApproveFarmer(0)
        setApproveStatus(0)
    }

    const [result, setResult] = useState(0);
    const [open, setOpen] = useState(false);
    const [openOne, setOpenOne] = useState(false);
    const [openTwo, setOpenTwo] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleCloseOne = () => {
        setOpenOne(false);
        setApproveFarmerDetails({
            ...approveFarmerDetails,
            farmerID: "0",
            farmerStatus: "0"
        })
        setFormData({
            ...formData,
            rejectReason: ""
        })
    };

    const handleCloseTwo = () => {
        setOpenTwo(false);
        setSearchQuery('');
        setPage(0);
    };

    function handleReject(farmerID, farmerStatus) {
        setApproveFarmerDetails({
            ...approveFarmerDetails,
            farmerID: parseInt(farmerID),
            farmerStatus: parseInt(farmerStatus)
        })
        setOpenOne(true);
        setRejectFarmer(0)
        setRejectStatus(0)
    }

    function handleRejectReason(e) {
        const target = e.target;
        const value = target.value
        setFormData({
            ...formData,
            [e.target.name]: value
        });
    }

    async function SupplierReject() {
        if (formData.rejectReason != "") {
            let model = {
                farmerID: parseInt(approveFarmerDetails.farmerID),
                farmerStatus: parseInt(approveFarmerDetails.farmerStatus),
                farmerCode: (approveFarmerCode),
                givenName: (approveGivenName),
                collectionCenterID: parseInt(approveCollectionCenterID),
                navisionNumber: (approvenavisionNumber),
                rejectReason: formData.rejectReason,
                createdBy: parseInt(TokenDecoder.getUserIDFromToken())
            }

            var res = await services.SaveFarmerRejectHistory(model);
            if (res.statusCode === "Success") {
                toast.success("Supplier Rejected successfully");
                trackPromise(GetFarmersByGroupIDAndOperationEntityID(values));
                handleCloseOne();
            } else {
                toast.error("Error occured in Supplier reject");
                handleCloseOne();
            }
        }
        else {
            toast.error("Reject Reason Required");
        }
    }

    function handleRejectDetalisList() {
        setOpenTwo(true);
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Supplier Creation  |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/farmer/addedit/" + AESEncryptionParam("0") + "/" + AESEncryptionParam("0")}
                        btname="Add"
                        pageName="Supplier Details"
                        leftButtonHidden={factoryType == 1 ? true : false}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}> Select Group</MenuItem>
                                        {generateGroupForDropDownMenu(groupList)}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Fresh Collection Center"
                                        value={formik.values.operationEntityID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityID')}
                                        error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                        helperText={touched.operationEntityID && errors.operationEntityID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}> All</MenuItem>
                                        {generateOperationEntityForDropDownMenu(operationEntityList)}
                                    </TextField>
                                    <TextField select
                                        fullWidth
                                        size="small"
                                        label="Supplier Type"
                                        value={formik.values.farmerTypeID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('farmerTypeID')}
                                    >
                                        <MenuItem value={0}> All Supplier Types</MenuItem>
                                        <MenuItem value={1}> Farmer</MenuItem>
                                        <MenuItem value={2}> Collector</MenuItem>
                                        <MenuItem value={3}> Farmer & Collector</MenuItem>
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Status"
                                        value={formik.values.isActive}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('isActive')}
                                        error={Boolean(touched.isActive && errors.isActive)}
                                        helperText={touched.isActive && errors.isActive}
                                    >
                                        <MenuItem key={0} value={0}>
                                            All Status
                                        </MenuItem>
                                        <MenuItem value={1}> New</MenuItem>
                                        <MenuItem value={2}> FCC Approved</MenuItem>
                                        <MenuItem value={3}> FDC First Approved</MenuItem>
                                        <MenuItem value={4}> FDC Second Approved</MenuItem>
                                        <MenuItem value={5}> FCC Rejected</MenuItem>
                                        <MenuItem value={6}> FDC First Rejected</MenuItem>
                                        <MenuItem value={7}> FDC Second Rejected</MenuItem>
                                    </TextField>
                                    <Grid item md={4} xs={12}>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color="error"
                                                onClick={() => clear()}
                                            > Clear</Button>
                                            <Button
                                                type="submit"
                                                variant="outlined"
                                                color="secondary"
                                            >Search</Button>
                                        </Stack>
                                    </Grid>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br />
                    {isEnable == false ?
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Grid item md={6} xs={12}>
                                {farmerRejectDetails.length > 0 && farmerDetails.length > 0 ?
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="left" >
                                        <Chip label="Rejected Suppliers" variant="outlined" color="error"
                                            onClick={handleRejectDetalisList}
                                        />
                                    </Stack> : null}
                            </Grid>
                            <Grid item md={6} xs={12}>
                            </Grid>
                        </Stack> : null}
                    <br />
                    {farmerDetails.length > 0 ?
                        <>
                            <Card>
                                <CustomTable
                                    tableData={farmerDetails}
                                    factoryType={factoryType}
                                    setEditFarmer={setEditFarmer}
                                    setApproveFarmer={setApproveFarmer}
                                    setApproveStatus={setApproveStatus}
                                    setRejectFarmer={setRejectFarmer}
                                    setRejectStatus={setRejectStatus}
                                    setApproveFarmerCode={setApproveFarmerCode}
                                    setApproveGivenName={setApproveGivenName}
                                    setApprovecollectionCenterID={setApprovecollectionCenterID}
                                    setApproveNavisionNumber={setApproveNavisionNumber}
                                    setEditFarmerCollectionCenterID={setEditFarmerCollectionCenterID}

                                />
                            </Card>
                        </> : <SearchNotFound searchQuery="Supplier Details" />}
                </Container>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData} headerMessage={approveFarmerDetails.farmerStatus == 2 ? message
                            : approveFarmerDetails.farmerStatus == 3 ? message1 : message2} viewPopup={EnableConfirmMessage}
                            discription={"Are you sure want to approve this Supplier details ?"} setViewPopup={setEnableConfirmMessage} />
                    </Grid>
                </div>
                <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
                    <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                        Required List !
                    </DialogTitle>
                    <DialogContent dividers>
                        {result == 1 || result == 3 || result == 6 || result == 7 ?
                            <Typography gutterBottom>
                                {result == 1 ? '1.' : result == 3 ? '1.' : result == 6 ? '1.' : result == 7 ? '1 .' : '2.'} Please upload farmer image before approval.
                            </Typography> : null}
                        {result == 2 || result == 3 || result == 6 ?
                            <Typography gutterBottom>
                                {result == 2 ? '1.' : result == 3 ? '2.' : result == 6 ? '2.' : '2.'} Please upload at least one farmer document before approval.
                            </Typography> : null}
                        {result == 5 || result == 3 || result == 7 ?
                            <Typography gutterBottom>
                                {result == 5 ? '1.' : result == 3 ? '3.' : result == 7 ? '2 .' : '2.'} Please upload a bank details of the farmer before approval.
                            </Typography> : null}
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={handleClose} color="secondary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog fullWidth={true} maxWidth='sm' onClose={handleCloseOne} aria-labelledby="customized-dialog-title" open={openOne}>
                    <DialogTitle id="customized-dialog-title" onClose={handleCloseOne}>
                        Supplier Reject !
                    </DialogTitle>
                    <DialogContent dividers>
                        <Grid item md={12} xs={12}>
                            <TextField
                                fullWidth
                                id="outlined-multiline-static"
                                label="Reject Reason *"
                                name='rejectReason'
                                value={formData.rejectReason}
                                onChange={(e) => { handleRejectReason(e) }}
                                multiline
                                rows={4}
                                variant="outlined"
                            />
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={SupplierReject} variant="contained" color="error">
                            Reject
                        </Button>
                        <Button autoFocus onClick={handleCloseOne} variant="outlined" color="secondary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog fullWidth={true} maxWidth="lg" onClose={handleCloseTwo} aria-labelledby="customized-dialog-title" open={openTwo}>
                    <DialogTitle id="customized-dialog-title" onClose={handleCloseTwo}>
                        <Grid container alignItems="center" justifyContent="space-between">
                            <Grid item>
                                Rejected Supplier List
                            </Grid>
                            <Grid item>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    size="small"
                                    id="search"
                                    label="Search"
                                    name="search"
                                    autoComplete="search"
                                    autoFocus
                                    value={searchQuery}
                                    onChange={handleSearchChange}
                                />
                            </Grid>
                        </Grid>
                    </DialogTitle>
                    <DialogContent dividers>
                        <Paper className={classes.paper}>
                            <TableContainer>
                                <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table">
                                    <EnhancedTableHeadOne
                                        classes={classes}
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleRequestSort}
                                        rowCount={filteredFarmerRejectDetails.length}
                                    />
                                    <TableBody>
                                        {paginatedRows.map((row, index) => {
                                            const labelId = `enhanced-table-checkbox-${index}`;

                                            return (
                                                <TableRow key={index}>
                                                    <TableCell component="th" id={labelId} scope="row">
                                                        {row.registrationNumber}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.modeOfOperation === 1
                                                            ? row.givenName != null
                                                                ? row.givenName
                                                                : row.businessName
                                                            : row.modeOfOperation === 2
                                                                ? row.givenName
                                                                : " - "}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.farmerTypeID === 1
                                                            ? "Farmer"
                                                            : row.farmerTypeID === 2
                                                                ? "Collector"
                                                                : row.farmerTypeID === 3
                                                                    ? "Farmer & Collector"
                                                                    : " - "}
                                                    </TableCell>
                                                    <TableCell align="left">{row.nic}</TableCell>
                                                    <TableCell align="left">
                                                        {row.farmerStatus === 1 ? (
                                                            <Chip size="small" label="New" style={{ color: "green" }} />
                                                        ) : row.farmerStatus === 2 ? (
                                                            <Chip size="small" label="FCC Approved" style={{ color: "orange" }} />
                                                        ) : row.farmerStatus === 3 ? (
                                                            <Chip size="small" label="FDC First Approved" style={{ color: "#B414F9" }} />
                                                        ) : row.farmerStatus === 4 ? (
                                                            <Chip size="small" label="FDC Second Approved" style={{ color: "blue" }} />
                                                        ) : row.farmerStatus === 5 ? (
                                                            <Chip size="small" label="FCC Rejected" style={{ color: "red" }} />
                                                        ) : row.farmerStatus === 6 ? (
                                                            <Chip size="small" label="FDC First Rejected" style={{ color: "red" }} />
                                                        ) : row.farmerStatus === 7 ? (
                                                            <Chip size="small" label="FDC Second Rejected" style={{ color: "red" }} />
                                                        ) : (
                                                            <Chip size="small" label="Active" style={{ color: "green" }} />
                                                        )}
                                                    </TableCell>
                                                    <TableCell align="left">{row.rejectReason}</TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </DialogContent>
                    <DialogActions>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={filteredFarmerRejectDetails.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                        <Button autoFocus onClick={handleCloseTwo} color="secondary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </Page>
        </>
    );
}